"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeadingDefault = exports.HeadingTagArray = exports.HeadingSizeArray = exports.HeadingSize = void 0;
var HeadingSize = {
  display1: '48px',
  h1: '42px',
  h2: '40px',
  h3: '32px',
  h4: '24px',
  h5: '18px',
  h6: '16px'
};
exports.HeadingSize = HeadingSize;
var HeadingSizeArray = ['display1', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
exports.HeadingSizeArray = HeadingSizeArray;
var HeadingTagArray = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
exports.HeadingTagArray = HeadingTagArray;
var HeadingDefault = {
  measure: 'h1',
  as: 'h1',
  children: 'Demo Text'
};
exports.HeadingDefault = HeadingDefault;